import React from 'react';
import {Card, Col, Form, Image, ProgressBar, Row} from 'react-bootstrap';
import ApiService from "../../api/ApiService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck, faCircleExclamation, faClock, faEye} from "@fortawesome/free-solid-svg-icons";
import CopyInfoModal from "../../components/CopyInfoModal";


export default function CopyTaskList() {
    const api = new ApiService();
    const [data, setData] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [hasMoreData, setHasMoreData] = React.useState(true); // 新增状态：是否有更多数据
    const [isFetching, setIsFetching] = React.useState(false); // 新增状态：是否正在获取数据
    const [copyInfoVisible, setCopyInfoVisible] = React.useState(false); // 新增状态：是否正在获取数据
    const [curCopyInfo, setCurCopyInfo] = React.useState(null); // 新增状态：是否正在获取数据
    // 模拟数据请求函数
    const fetchMoreData = async () => {
        if (!hasMoreData || isFetching) return; // 如果没有更多数据或正在获取数据，直接返回

        setIsFetching(true); // 设置为正在获取数据

        const reponse = await api.getAgentCopyList(20, currentPage);
        if (reponse){
            const newData = reponse.data;
            // const newData = Array.from({length: 10}, (_, index) => ( {
            //     "id": 1752065669900092,
            //     "cozeSpaceId": 1752053393860082,
            //     "agentId": 1,
            //     "authId": 0,
            //     "status": index==0 ? -1 : index % 2 === 0 ? 1 : 2,
            //     "reason": "",
            //     "created": "2025-07-09T20:54:29+08:00",
            //     "agent": {
            //         "id": 1,
            //         "title": "测试智能体测试智能体测试智能体",
            //         "badge": "https://taskmp.styleart.cn/2025-07-08/psdByG6tVd.png",
            //         "video": "https://taskmp.styleart.cn/2025-07-08/j2qj2Z4AIy.mp4",
            //         "cover": "https://taskmp.styleart.cn/2025-07-08/ZViLONaY9n.png",
            //         "content": "测试智能体描述测试智能体描述测试智能体描述测试智能体描述",
            //         "allowCopy": false,
            //         "vip": 0,
            //         "cozeUrl": "",
            //         "instructions": "\u003cp\u003e\u003c/p\u003e",
            //         "flows": null,
            //         "created": "2025-07-08T17:42:50+08:00",
            //         "updated": "2025-07-08T17:42:50+08:00"
            //     },
            //     "cozeSpace": {
            //         "id": 1752053393860082,
            //         "userId": 80779739,
            //         "url": "邀请你加入我的扣子空间\"TONY测试\"，链接将在 2025-07-16 17:29 过期\n👉🏻 https://www.coze.cn/invite/YSWVnsfYX9nEfBWR2CSB?type=1",
            //         "joinStatus": 0,
            //         "cozeSpaceId": "",
            //         "title": "",
            //         "cover": "",
            //         "subTitle": "",
            //         "created": "2025-07-09T17:29:53+08:00"
            //     }
            // }));
            if (newData.length < 20) {
                setHasMoreData(false);
            }
            setData(prevData => [...prevData, ...newData]);
            setCurrentPage(prevPage => prevPage + 1);
            setIsFetching(false); // 重置为未获取数据状态
        }


    };

    // 使用 Intersection Observer 监听元素是否进入视口
    const observer = React.useRef();
    const lastElementRef = React.useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreData && !isFetching) { // 只有在还有更多数据且未获取数据时才触发加载
                fetchMoreData();
            }
        });
        if (node) observer.current.observe(node);
    }, [hasMoreData, isFetching]);

    return (
        <>
            {/* 内容区域 */}
            <Row>
                {/* 搜索框和按钮 */}
                <Col xs={12} style={{
                    whiteSpace: 'nowrap',
                    position: 'sticky',
                    display: 'flex',
                    zIndex: '999',
                    top: '56px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '10px',
                    width: '100%', // 确保宽度是固定的或自适应的
                    background: '#0a0e17', // 防止内容透过
                    padding: '4px 10px' // 可选：添加一些垂直内边距来避免内容紧贴边缘
                }}>
                    <Form.Control type="search" placeholder="搜索迁移任务..." style={{borderRadius: '8px'}}/>

                    <span style={{color: '#02C8E3', marginLeft: '10px'}}>共 {data.length} 个迁移任务</span>
                </Col>
                {data.length === 0 &&
                    <Col className={'flex-column'} xs={12} style={{
                        backgroundColor: '#1E2129',
                        minHeight: '240px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '10px'
                    }}>
                        <img src="/images/coze/coze_notice_tip.svg" alt="暂无数据" width={40} height={40}
                             style={{display: 'block'}}/>
                        <h5 className={'text-center text-white mt-2'}>暂无迁移任务</h5>
                        <p className={'text-center'}
                           style={{color: '#777777'}}>您可以在工作流集合页面创建新的迁移任务</p>
                    </Col>
                }

                {/* 卡片展示区 */}
                <Col xs={12}>
                    <Row>
                        {data.map((card, index) => (
                            <Col key={index} xs={12} md={6} lg={4} xxl={3} style={{marginTop: '10px', marginBottom: '10px'}}>
                                <Card style={{borderRadius: '8px',backgroundColor: '#2A2F3B'}}>

                                    <Card.Body style={{padding:'0'}}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '16px'
                                        }}>
                                            <Image src={'/images/logo.svg'} width={'32px'} height={'32px'}/>
                                            <div style={{
                                                backgroundColor: '#1E222D',
                                                width: '100%',
                                                marginLeft: '10px',
                                                textAlign: 'left',
                                                padding: '10px',
                                                borderRadius: '8px'
                                            }}>
                                                <p style={{
                                                    color: '#D1D1D1',
                                                    fontSize: '16px',
                                                    marginBottom: '0px',
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: 1, overflow: 'hidden',
                                                    overflowWrap: 'anywhere'
                                                }}>
                                                    {card.agent.title}
                                                </p>
                                                <p style={{
                                                    color: '#889094',
                                                    fontSize: '14px',
                                                    marginBottom: '0px',
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: 1, overflow: 'hidden',
                                                    overflowWrap: 'anywhere'
                                                }}>
                                                    {card.agent.content}
                                                </p>
                                            </div>
                                        </div>

                                        <div style={{backgroundColor:'#313644',padding:'16px',}}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginTop: '10px'
                                            }}>
                                            <span style={{
                                                backgroundColor: card.status === 2?'#02C8E3':(card.status === -1?'#DE4444':'#f4f238'),
                                                borderRadius: '50px',
                                                fontSize: '12px',
                                                padding: '2px 10px',
                                            }}>
                                            {card.status === 2 && <FontAwesomeIcon icon={faCircleCheck} size={'1x'}
                                                                                   style={{marginRight: '4px'}}/>}
                                                {card.status != -1 && card.status != 2 &&
                                                    <FontAwesomeIcon icon={faClock} size={'1x'}
                                                                     style={{marginRight: '4px'}}/>}
                                                {card.status === -1 &&
                                                    <FontAwesomeIcon icon={faCircleExclamation} size={'1x'}
                                                                     style={{marginRight: '4px'}}/>}
                                                {card.status === 2 ? '人工迁移成功' : (card.status === -1 ? '失败' : '复制中')}</span> {/* 添加 状态 标签 */}
                                                <span style={{color: '#B4BFC5', fontSize: '12px'}}>ID: {card.id}</span>
                                            </div>
                                            <div style={{
                                                marginTop: '10px'
                                            }}>
                                                <ProgressBar completed={card.status === 2 ? 100 : 0} now={card.status === 2 ? 100 : 0}  style={{height: '6px','--bs-progress-bar-bg': '#02C8E3'}} />
                                                <span style={{color: '#B4BFC5', fontSize: '12px',display: 'flex', justifySelf: 'end',marginTop: '10px'}}>进度：{card.status === 2 ? '100%' : '0%'}</span>
                                            </div>
                                        </div>


                                        <span
                                            onClick={() => {
                                                setCurCopyInfo(card)
                                                setCopyInfoVisible(true)
                                            }}
                                            style={{
                                            backgroundColor: '#1E212A',
                                            color: '#02C8E3',
                                            borderRadius: '50px',
                                            fontSize: '16px',
                                            padding: '4px 24px',
                                            display: 'block',
                                            margin: '10px',
                                            marginRight: '16px',
                                            justifySelf: 'end',
                                        }}>
                                            <FontAwesomeIcon icon={faEye} size={'1x'}
                                                                                   style={{marginRight: '4px'}}/>
                                            详情</span>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
                {/* 观察目标元素 */}
                {hasMoreData ? (
                    <div ref={lastElementRef}
                         style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>加载更多...</div>
                ) : (
                        data.length > 0&&(
                            <div style={{
                                textAlign: 'center',
                                marginTop: '20px',
                                color: 'white'
                            }}> 没有更多数据了</div>
                        )
                )}
            </Row>
            <CopyInfoModal visible={copyInfoVisible} copyInfo={curCopyInfo}  onClose={() => setCopyInfoVisible(false)}/>
        </>
    );
}
